import type { ReactNode } from 'react'

import { cn } from '@/lib/utils'

export type PageHeaderStackProps = {
  children: ReactNode
  /** Tighter gap before tabs or title-only chrome (`gap-3`). Default `gap-6` for filters and toolbars. */
  compact?: boolean
  className?: string
}

/**
 * Groups `PageHeader` with an adjacent toolbar (search, filters). Default gap is
 * `gap-6` (24px) — the standard section-to-section rhythm (`PageContainer` inner
 * `space-y-6`). Use `compact` for `PageLineTabs` or title-only + search when there is no description.
 */
export function PageHeaderStack({ children, compact = false, className }: PageHeaderStackProps) {
  return (
    <div className={cn('flex flex-col', compact ? 'gap-3' : 'gap-6', className)}>{children}</div>
  )
}
